// extracted by mini-css-extract-plugin
export default {"body":"Arquivos_body__5rBk9","container":"Arquivos_container__iuxcA"};